module.exports = __webpack_public_path__ + "img/fixed_fluid_taps.d05bf5ef.svg";